// Contextual internal-linking catalog + per-topic recipes.
// RelatedClaimHelp.jsx calls getContextualLinks(topic, currentPath) so each
// page shows a SMALL set (3–6) of links that are genuinely relevant to that
// page's topic — NOT the same six links sitewide. Anchors rotate per source
// page so the same target isn't linked with identical anchor text everywhere.
// Self-links are always excluded.

const catalog = {
  tampa: {
    to: "/public-adjuster-tampa",
    anchors: [
      "Tampa public adjuster",
      "public adjuster in Tampa",
      "Tampa insurance claim help",
      "Tampa property claim assistance",
    ],
  },
  pasco: {
    to: "/public-adjuster-pasco-county",
    anchors: [
      "Pasco County public adjuster",
      "public adjuster in Pasco County",
      "Pasco County claim help",
    ],
  },
  wind: {
    to: "/wind-damage",
    anchors: [
      "wind damage public adjuster",
      "Florida wind claim help",
      "windstorm insurance claim help",
      "hurricane & wind claim adjuster",
    ],
  },
  water: {
    to: "/water-damage",
    anchors: [
      "water damage claim help",
      "Tampa water damage insurance claim",
      "water damage public adjuster",
      "burst pipe claim help",
    ],
  },
  roof: {
    to: "/roof-claim-denial-florida",
    anchors: [
      "roof damage claim help",
      "denied roof claim assistance",
      "Florida roof insurance claim",
    ],
  },
  underpaid: {
    to: "/underpaid-insurance-claim-florida",
    anchors: [
      "underpaid insurance claim help",
      "recover an underpaid claim",
      "insurance underpayment recovery",
    ],
  },
  denied: {
    to: "/denied-insurance-claim-florida",
    anchors: [
      "denied insurance claim help",
      "appeal a denied claim",
      "reopen a denied claim",
    ],
  },
  fees: {
    to: "/how-much-does-a-public-adjuster-cost-in-florida",
    anchors: [
      "how much a public adjuster costs in Florida",
      "Florida public adjuster fees",
      "public adjuster fee caps in Florida",
    ],
  },
  calculator: {
    to: "/claim-calculator",
    anchors: [
      "free claim estimate calculator",
      "estimate your claim value",
      "run a free claim estimate",
    ],
  },
  roofcalc: {
    to: "/roof-claim-calculator",
    anchors: ["roof claim calculator", "estimate your roof claim"],
  },
  watercalc: {
    to: "/water-damage-claim-calculator",
    anchors: ["water damage calculator", "estimate your water claim"],
  },
};

// Ordered, topic-specific recipes (keys into the catalog).
const recipes = {
  wind: ["roof", "underpaid", "denied", "calculator", "tampa"],
  water: ["underpaid", "watercalc", "denied", "tampa", "calculator"],
  roof: ["roofcalc", "underpaid", "denied", "wind", "tampa"],
  underpaid: ["calculator", "denied", "roof", "water", "wind", "tampa"],
  denied: ["underpaid", "calculator", "roof", "water", "wind", "tampa"],
  fees: ["tampa", "denied", "underpaid", "wind", "water"],
  guide: ["tampa", "fees", "denied", "underpaid", "wind"],
  city: ["wind", "water", "roof", "denied", "underpaid", "fees"],
  generic: ["tampa", "denied", "underpaid", "calculator", "fees"],
};

const hash = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
};

// Returns 3–6 contextual links for a topic, excluding a self-link, each with
// a rotated anchor derived from the source path.
export const getContextualLinks = (topic, currentPath, limit = 6) => {
  const keys = recipes[topic] || recipes.generic;
  return keys
    .map((k) => catalog[k])
    .filter((t) => t && t.to !== currentPath)
    .map((t, i) => ({
      to: t.to,
      anchor: t.anchors[hash(currentPath + t.to + i) % t.anchors.length],
    }))
    .slice(0, limit);
};
